import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {PartnerType} from "../../../../classes/partnerType";
import {kanPartnersService} from "../../../services/services/partners";

@Component({
    selector: 'kan-partner-type-dialog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanPartnerTypeDialog {
    public partnerType: PartnerType = new PartnerType();
    public isNew: boolean = true;

    public partnerTypeForm: FormGroup;

    constructor(private dialogRef: MatDialogRef<kanPartnerTypeDialog>,
                private formBuilder: FormBuilder,
                private partnersService: kanPartnersService,
                @Inject(MAT_DIALOG_DATA) private data: any) {

        if (this.data && this.data.partnerType) {
            this.partnerType = JSON.parse(JSON.stringify(this.data.partnerType));
            this.isNew = false;
        }
    }

    ngOnInit(): void {
        this.partnerTypeForm = this.formBuilder.group({
            type: new FormControl(this.partnerType.type, [Validators.required]),
            description: new FormControl(this.partnerType.description)
        });
    }

    public addPartnerType(event: any) {

        this.partnersService.addPartnerType(this.partnerType)
            .then((note) => {
                this.dialogRef.close('add');
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public updatePartnerType(event: any) {

        this.partnersService.updatePartnerType(this.partnerType)
            .then((note) => {
                this.dialogRef.close('update');
            })
            .catch((error) => {
                console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/dialogs/partner-type-dialog/component.ts